import { render, staticRenderFns } from "./HomeForOtherOfficeService.vue?vue&type=template&id=59586df2&scoped=true&lang=pug"
import script from "./HomeForOtherOfficeService.vue?vue&type=script&lang=ts"
export * from "./HomeForOtherOfficeService.vue?vue&type=script&lang=ts"
import style0 from "./HomeForOtherOfficeService.vue?vue&type=style&index=0&id=59586df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59586df2",
  null
  
)

export default component.exports